export const options = {
    autoplay: false,
    controls: true,
    responsive: true,
    live: false,
    loop: false,
    seekable: false
};